import React from "react";

import { confirmable } from "react-confirm";

import { Button, Icon } from "semantic-ui-react";

import { AccessibleModal } from "simplydo/react/components/Accessibility/AccessibleModal";

class Dialog extends React.Component {
  render() {
    const { show, proceed, dismiss, cancel, title, confirmation } = this.props;
    return (
      <AccessibleModal
        mountNode={document.getElementById("semantic-modal-mount-node")}
        open={show}
        onClose={dismiss}
        basic
        size="small"
        className="no-scroll"
      >
        <AccessibleModal.Header content={title} />
        <AccessibleModal.Content>{confirmation}</AccessibleModal.Content>
        <AccessibleModal.Actions>
          <Button basic inverted onClick={cancel}>
            <Icon name="remove" /> Cancel
          </Button>
          <Button primary onClick={proceed}>
            <Icon name="checkmark" /> Confirm
          </Button>
        </AccessibleModal.Actions>
      </AccessibleModal>
    );
  }
}

export default confirmable(Dialog);
